(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mamu-vista-360"] && !Shopify.designMode) return;
  try {
    
  class MamuVista360 extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('[data-range]');
      this.current = this.querySelector('[data-current]');
      this.slides = Array.from(this.querySelectorAll('.mamu-v360__slide'));
      this.onInput = () => this.show(Number(this.range?.value ?? 1));
      this.range?.addEventListener('input', this.onInput);
    }

    disconnectedCallback() {
      this.range?.removeEventListener('input', this.onInput);
    }

    /** @param {number} index Vista a mostrar (base 1) */
    show(index) {
      this.slides.forEach((slide, i) => slide.toggleAttribute('data-active', i + 1 === index));
      if (this.current) this.current.textContent = String(index);
    }
  }

  if (!customElements.get('mamu-vista-360')) customElements.define('mamu-vista-360', MamuVista360);

  } catch(e) { console.error(e); }
})();
})();
